import { ReactElement } from 'react';

import { DRAWER_CLASS } from '../../utils/constants';
import Button from '../Button/Button';
import CrossIcon from '../Icon/components/Cross';
import * as Styled from './Drawer.styles';
import { IDrawerProps } from './Drawer.types';

const Drawer = ({
  children,
  className = '',
  size = 'medium',
  header,
  footerAlignment = 'right',
  onClose,
  onCancel,
  cancelText = 'Cancel',
  onConfirm,
  confirmText = 'Confirm',
  sticky = false,
  paddings = 'tight',
  bodyPadding = true,
  borders = true,
  ...rest
}: IDrawerProps): ReactElement => (
  <Styled.Drawer className={className} handler={false} prefixCls={DRAWER_CLASS} onClose={onClose} {...rest}>
    {header && (
      <Styled.DrawerHeader size={size} sticky={sticky} paddings={paddings} borders={borders}>
        {header}
        <Button icon={<CrossIcon />} iconOnly variant="transparent" size="small" onClick={onClose} />
      </Styled.DrawerHeader>
    )}

    <Styled.DrawerContent size={size} paddings={paddings} bodyPadding={bodyPadding}>
      {children}
    </Styled.DrawerContent>

    {(onCancel || onConfirm) && (
      <Styled.DrawerFooter
        size={size}
        footerAlignment={footerAlignment}
        sticky={sticky}
        paddings={paddings}
        borders={borders}
      >
        {onCancel && (
          <Button size={size} variant="transparent" onClick={onCancel}>
            {cancelText}
          </Button>
        )}
        {onConfirm && (
          <Button size={size} onClick={onConfirm}>
            {confirmText}
          </Button>
        )}
      </Styled.DrawerFooter>
    )}
  </Styled.Drawer>
);

export default Drawer;
